module.exports = __webpack_public_path__ + "img/partner_2.73d12e6c.jpg";